import { render, staticRenderFns } from "./CompareHistoryTablePagination.vue?vue&type=template&id=32cb6c38"
import script from "./CompareHistoryTablePagination.vue?vue&type=script&lang=js"
export * from "./CompareHistoryTablePagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports